import { Component, OnInit } from '@angular/core';
import { AlertService } from 'src/app/_services/alert.service';
import { UserDashboardService } from '../user-dashboard.service';
import Swal from 'sweetalert2';
import { DatePipe, Location } from '@angular/common';
import { Router } from '@angular/router';
import { MenusService } from 'src/app/_services/menu.service';
import { ColDef, GridApi, GridReadyEvent, PaginationChangedEvent } from 'ag-grid-community';
import { firstValueFrom } from 'rxjs';
import { BtnCellRenderer1 } from 'src/app/common/button-cell-renderer.component1';
import { environment } from 'src/environments/environment';
const { defaultCurrency, defaultPageSizeArr, defaultPageSize } = environment;

@Component({
  selector: 'app-merchant-dashboard',
  templateUrl: './merchant-dashboard.component.html',
  styleUrls: ['./merchant-dashboard.component.scss']
})
export class MerchantDashboardComponent implements OnInit {
  searchEmailId: string;
  searchWalletId: string;
  searchMobileNumber: string;

  businessDetails: any = {};
  
  deviceDetails: any = {};

  walletDetails: any = {};

  selectedTab: number = 0;

  displayDetails: boolean = false;

  isOperationsUser: boolean = false;

  public permissions: string = '';

  documentList: any[] = [];

  uuid:any;

  
  stateOptions = [
      { FieldText: "ABU DHABI", FieldValue: 37 },
      { FieldText: "DUBAI", FieldValue: 38 },
      { FieldText: "SHARJAH", FieldValue: 39 },
      { FieldText: "AJMAN", FieldValue: 40 },
      { FieldText: "UMM AL QUWAIN", FieldValue: 41 },
      { FieldText: "RAS AL KHAIMAH", FieldValue: 42 },
      { FieldText: "FUJAIRAH", FieldValue: 43 },
  ];


  public columnDefs: ColDef[];

  // for transaction details
  private gridApi!: GridApi;
  currentPage: number = 1;
  pageSize: number = defaultPageSize;
  pageSizeArr: any = defaultPageSizeArr;
  pageNumber: any = 0;
  totalRecords: number = 0;
  transactionDetails: any[] = [];
  transactionColumnDefs: ColDef[] = [
    { field: 'dateTime', sortable: false, lockVisible: true, headerName: 'Trxn Initiated Date' },
    { field: 'updateDateTime', sortable: false, lockVisible: true, headerName: 'Trxn Posted Date' },
    { field: 'merchantIdentifierId', sortable: false, lockVisible: true, headerName: 'Merchant ID' },
    { field: 'walletSenderId', sortable: false, lockVisible: true, headerName: 'Sender Wallet ID' },
    { field: 'senderName', sortable: false, lockVisible: true, headerName: 'Sender Name' },
    { field: 'walletReceiverId', sortable: false, lockVisible: true, headerName: 'Receiver Wallet ID' },
    { field: 'receiverName', sortable: false, lockVisible: true, headerName: 'Receiver name' },
    { field: 'receiverType', sortable: false, lockVisible: true, headerName: 'Receiver Type' },
    { field: '', sortable: false, lockVisible: true, headerName: 'Auth Code' },
    { field: 'typeOfTransaction', sortable: false, lockVisible: true, headerName: 'Transaction Type' },
    { field: 'productCode', sortable: false, lockVisible: true, headerName: 'MoPayment' },
    { field: 'narration', sortable: false, lockVisible: true, headerName: 'Title/Narration' },
    { field: 'txnId', sortable: false, lockVisible: true, headerName: 'Trxn ID' },
    { field: 'merchantReferenceId', sortable: false, lockVisible: true, headerName: 'Order ID' },
    { field: 'serviceProviderTxnId', sortable: false, lockVisible: true, headerName: 'SP Transaction ID' },
    { field: 'status', sortable: false, lockVisible: true, headerName: 'Transaction Status' },
    { field: 'transactionType', sortable: false, lockVisible: true, headerName: 'CR/DR' },
    { field: 'sendingCurrency', sortable: false, lockVisible: true, headerName: 'Sender Currency' },
    { field: 'currency', sortable: false, lockVisible: true, headerName: 'Receiver Currency' },
    { field: 'exchangeRate', sortable: false, lockVisible: true, headerName: 'FX Rate' },
    { field: 'openingBal', sortable: false, lockVisible: true, headerName: 'Opening Balance' },
    { field: 'amount', sortable: false, lockVisible: true, headerName: 'Trxn Amt' },
    { field: 'serviceCharges', sortable: false, lockVisible: true, headerName: 'Service Charges' },
    { field: 'vat', sortable: false, lockVisible: true, headerName: 'VAT AMT' },
    { field: 'totalAmount', sortable: false, lockVisible: true, headerName: 'Net Amount' },
    { field: '', sortable: false, lockVisible: true, headerName: 'Discounts/Promo code' },
    { field: 'closingBal', sortable: false, lockVisible: true, headerName: 'Closing Balance' }
  ]
  transactionTableSelectedColumn: ColDef[] = [...(this.transactionColumnDefs.filter((col) => !col?.hide))];

  public defaultColDef: ColDef = {
    flex: 1,
    minWidth: 150,
    resizable: true,
    sortable: true,
    filter: false,
    autoHeight: true
  };

  tableSelectedColumn: ColDef[];

  constructor(private alertService: AlertService, private userDashboardService: UserDashboardService, private location: Location, private router: Router, private menuService: MenusService, private datePipe: DatePipe) { }

  async ngOnInit() {
    const path = this.location.prepareExternalUrl(this.location.path());
    this.permissions = this.menuService.getPermissions(path);
    if (this.permissions == null || this.permissions == '' || !this.permissions) {
      this.alertService.errorAlert({
        title: "No Access",
        backdrop: true,
        toast: true,
        timer: 1500
      })
      await this.router.navigateByUrl('/');
    }
    this.isOperationsUser = this.permissions.includes("Edit");
    this.columnDefs = [
      { field: 'docid', headerName: 'Document ID', lockVisible: true, resizable: true, cellRenderer: 'agGroupCellRenderer' },
      { field: 'document', headerName: 'Document', lockVisible: true, },
      { field: 'isUploaded', headerName: 'Uploaded', lockVisible: true, },
      {
        field: 'actions', headerName: 'Actions', lockVisible: true, hide: !this.isOperationsUser, width: 180, cellRenderer: BtnCellRenderer1, cellRendererParams: [
          {
            clicked: (event: any, param: any) => {
              this.userDashboardService.download(this.uuid, param.data.docname).subscribe((resp) => {
                this.download(resp, param.data.docname, param.data.docType);
              });
            },
            buttonIconClass: 'icon-download'
          },
        ]
      }
    ]
    this.tableSelectedColumn = [...(this.columnDefs.filter((col) => !col?.hide))];

  }

  async search() {
    this.displayDetails = false;
    var flagNotNull = 0;
    var flagUserIdFound = 0;
    var userIds = new Set();
    if (this.searchMobileNumber != null && this.searchMobileNumber.trim().length != 0) {
      flagNotNull++;
      var userId = this.extractUserId(await firstValueFrom(this.userDashboardService.getUserId("MOBILE", this.searchMobileNumber.trim(), "MERCHANT")!));
      if (userId) {
        this.uuid = userId;
        flagUserIdFound++;
        userIds.add(userId)
      }
    }
    if (this.searchEmailId != null && this.searchEmailId.trim().length != 0) {
      flagNotNull++;
      var userId = this.extractUserId(await firstValueFrom(this.userDashboardService.getUserId("EMAIL", this.searchEmailId.trim(), "MERCHANT")!));
      if (userId) {
        this.uuid = userId;
        flagUserIdFound++;
        userIds.add(userId)
      }
    }
    if (this.searchWalletId != null && this.searchWalletId.trim().length != 0) {
      flagNotNull++;
      var userId = this.extractUserId(await firstValueFrom(this.userDashboardService.getUserId("WALLET", this.searchWalletId.trim(), "MERCHANT")!));
      if (userId) {
        this.uuid = userId;
        flagUserIdFound++;
        userIds.add(userId)
      }
    }
    if (flagNotNull == 0) {
      this.alertService.toastWarringMessageAlertWithMessage("Please enter atleast one field to search");
      return;
    }
    console.log("Flags", flagNotNull, flagUserIdFound);
    if ((flagNotNull != flagUserIdFound) || (userIds.size > 1 && userIds.size != 0)) {
      Swal.fire("User not found", undefined, "error");
    } else {
      var userId: any = [...userIds][0];
      this.handleSearchResponse(userId);
    }
  }

  handleUserDetailsResponse(resp: any): void {
    if (resp != null && resp.response != null && resp.response.data != null) {
      this.businessDetails = resp.response.data;
      this.businessDetails.dateOfIncorporation = this.datePipe.transform(this.businessDetails.registrationDate, 'MM/dd/yyyy');
      for(var i=0;i<this.stateOptions.length;i++){
        if(this.stateOptions[i].FieldValue==this.businessDetails.state){
          this.businessDetails.emirate = this.stateOptions[i].FieldText;
          break;
        }
      }
    }
  }

  handleDeviceInfoDetailsResponse(resp: any): void {
    if (resp != null && resp.response != null && resp.response.data != null) {
      this.deviceDetails = resp.response.data;
    }
  }

  handleWalletDetailsResponse(resp: any): void {
    if (resp != null && resp.response != null && resp.response.data != null) {
      this.walletDetails = resp.response.data;
    }
  }

  handleDocumentsResponse(resp: any): void {
    if (resp != null) {
      this.documentList = resp.map((_ : any)=> {
        var flag = false;
        if (_.docpath){
          flag = true;
        }
        _.isUploaded = flag ? "Yes" : "No";
        _.reviewFlag = flag;
        return _;
      });
    }
  }

  download(resp: any, fileName: any, fileType: any){
    console.log(resp);
    const linkSource = 'data:application/' + fileType + ';base64,' + resp.Data;
    const downloadLink = document.createElement("a");
    downloadLink.href = linkSource;
    downloadLink.download = fileName;
    downloadLink.click();
  }

  extractUserId(resp: any) {
    if (resp != null && resp.response != null) {
      var response = resp.response;
      if (response.status == 200) {
        return response.data;
      }
    }
    return null;
  }

  handleSearchResponse(userId: string) {
    this.displayDetails = true;
    this.userDashboardService.getUserDetails(userId, "MERCHANT","").subscribe((resp) => {
      this.handleUserDetailsResponse(resp);
    });

    this.userDashboardService.getDeviceInfoDetails(userId).subscribe((resp) => {
      this.handleDeviceInfoDetailsResponse(resp);
    });

    this.userDashboardService.getWalletDetails(userId).subscribe((resp) => {
      this.handleWalletDetailsResponse(resp);
    });

    this.userDashboardService.getDocuments(userId).subscribe((resp) => {
      this.handleDocumentsResponse(resp);
    });

    this.fetchTransactionDetails(userId);
  }

  fetchTransactionDetails(userId?: string) {
    console.log("fetchTransactionDetails")
    this.userDashboardService.getTransactionReportListForMerchant(userId??this.uuid, this.pageSize, this.pageNumber)
    .subscribe((resp: any) => {
      if (resp?.response?.status === 200) {
        this.transactionDetails = resp.response.data.content;
        this.totalRecords = resp.response.data.totalElements;
        this.transactionDetails.forEach((_: any) => {
          _.sendingCurrency = defaultCurrency;
          _.serviceCharges ??= 0;
          _.vat ??= 0;
          _.openingBal ??= 'NA';
          _.closingBal ??= 'NA';
       })
      }
    })
  }

  onTransactionGridReady(params: GridReadyEvent) {
    this.gridApi = params.api;
    this.gridApi.paginationSetPageSize(this.pageSize);
  }

  onPageSizeChanges($event: Event) {
    console.log("onPageSizeChanges: " + this.pageSize)
    this.gridApi.paginationSetPageSize(this.pageSize)
    this.gridApi.applyTransaction({ remove: this.transactionDetails })
    this.gridApi.showLoadingOverlay();
    this.pageNumber = 0;
    this.fetchTransactionDetails(this.uuid);
  }

  onPaginationChange(param: PaginationChangedEvent | any) {
    console.log("onPaginationChange: " + param);
    this.gridApi.applyTransaction({ remove: this.transactionDetails })
    this.gridApi.showLoadingOverlay();
    this.pageNumber = (param - 1)
    this.fetchTransactionDetails(this.uuid);
  }
}
